import React from "react";
import { formatDate, sortRentals, readableDate } from "../../utils";
import { useRentalsData } from "../../hooks/useRentalsData";
import { useSelector } from "react-redux";
import { getRentalsData } from "../../state/selectors";
import {Box, Cell, Column, Columns, Grid, Title} from "@allxsmith/bestax-bulma";
import { Link } from "react-router-dom";

const DATES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

function Rentals(props) {
  const complete = useRentalsData({
    start_date: props.dates.start,
    finish_date: props.dates.end
  });
  const data = useSelector(getRentalsData);
  if (!complete) {
    return <p>Not Ready</p>;
  }

  const rentals = sortRentals(data.results, props.dates.start);
  return (
    <Box>
      <Title>Rentals</Title>
      <Columns isMultiline>
        {DATES.map((day, index) => {
          let monday = new Date(props.dates.start);
          monday.setDate(monday.getDate() + index);

         return (
            <Column className="rental-column" key={day}>
              <Title size="5">{day}</Title>
              <p className="is-size-7">{readableDate(formatDate(monday))}</p>
              <Title size="6">
                £{rentals.day_totals[index].toFixed(2)}
              </Title>
              <Grid style={{ padding: "0px" }}>
                {rentals.day_rentals[index].map(rental => (
                  <Cell
                    className="rental-homepage-tile"
                    key={rental.id}
                  >
                    <Link target="_self" to={"/editrental/" + rental.id}>
                      <p className="no-underline is-size-7">
                        {rental.customer.display_name}
                      </p>
                      <p
                        size={6}
                        className="no-underline registration-field registration-homepage"
                      >
                        {rental.vehicle.registration}
                      </p>
                    </Link>
                  </Cell>
                ))}
              </Grid>
            </Column>
          );
        })}
      </Columns>
    </Box>
  );
}

export default Rentals;
